import { Button, FloatingLabel, Form, Offcanvas } from "olive-react-myoneui";
import ProfileCard from "./ProfileCard";

function EditOffcanvas({
  show,
  onClose,
  subjectId,
  updateSubjects,
  setImage,
  image,
  name,
  setName,
  setNewImage,
}) {
  return (
    <Offcanvas className="pb-0" show={show} onHide={onClose} placement="end">
      <Offcanvas.Header closeButton backButton="Close" icon="close" className="pb-0">
        <Offcanvas.Title>Edit Subject</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <p className="help-text fs-6 fw-semibold">
          Please fill the form below and edit subjects title.
        </p>

        <ProfileCard
          title="Upload Subject Picture"
          onFileSelect={setNewImage}
          image={image}
          multiple={true}
        />

        <FloatingLabel controlId="subjectTitleId" label="Subject Title" className="mb-4">
          <Form.Control
            type="text"
            placeholder="Subject Title"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </FloatingLabel>
      </Offcanvas.Body>
      <Offcanvas.Footer>
        <Button variant="default" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={() => updateSubjects(image, name, subjectId)}>
          Save
        </Button>
      </Offcanvas.Footer>
    </Offcanvas>
  );
}

export default EditOffcanvas;
